'use client'

import { ReactNode } from 'react'

import { queryClient } from '@/api'
import { Toastify } from '@/components/commons'
import { AuthProvider } from '@/contexts/auth/AuthProvider'
import { BreadcrumbsProvider } from '@/contexts/breadcrumbs/BreadcrumbsProvider'
import { IBreadcrumbsOptions } from '@/contexts/breadcrumbs/types'
import { ModalBaseProvider } from '@/contexts/modalBase/ModalBaseProvider'
import { SidebarProvider } from '@/contexts/sidebar/SidebarProvider'
import { ISidebarCookies } from '@/contexts/sidebar/types'
import { DatadogProvider } from '@/plugins/datadog/rum'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

export type UserInformations = {
  userUuid: string
  tenantId: string
  token: string
  expiresToken: Date
  companyUuid: string
}

export interface ProvidersProps {
  children: ReactNode
  userInformations: UserInformations
  sidebarCookies: ISidebarCookies
  breadcrumbsOptions?: IBreadcrumbsOptions
}

export default function Providers({
  children,
  userInformations,
  sidebarCookies,
}: ProvidersProps) {
  return (
    <DatadogProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider userInformations={userInformations}>
          <BreadcrumbsProvider>
            <SidebarProvider sidebarCookies={sidebarCookies}>
              <ModalBaseProvider>
                <Toastify>{children}</Toastify>
              </ModalBaseProvider>
            </SidebarProvider>
          </BreadcrumbsProvider>
        </AuthProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </DatadogProvider>
  )
}
